









































































import { Component, Vue, Watch, Ref, Prop } from 'vue-property-decorator'
import { Route } from 'vue-router'
interface Item {url: string, fileName: string, createTime: string}
@Component({
  name: 'comment',
  components: {
  }
})
export default class extends Vue {
  @Prop({ default: false }) private isShowOnlyIcon!: boolean
  @Prop({ default: false }) private isHiddenDelBtn!: boolean
  @Prop({ default: '100%' }) private ItemWidth!: boolean
  @Prop({ default: () => [] }) private list!: Item[]
  @Prop({ default: null}) private progress!: {name: string, percent: number}
  private types = {
    doc: ['doc', 'docx'],
    ppt: ['ppt', 'pptx'],
    xls: ['xls', 'xlsx'],
    video: ['mp4'],
    audio: ['mp3', 'wav', 'ogg'],
    txt: ['txt'],
    pdf: ['pdf'],
    zip: ['zip', 'rar'],
    json: ['json'],
    img: ['jpg', 'jpeg', 'gif', 'png', 'bmp']
  }
  private typeList: string[] = []
  private get listShow () {
    return this.list.map(({fileName, url}) => {
      let dot = fileName.lastIndexOf('.')
      let name = fileName.slice(0, dot)
      let suffix = fileName.slice(dot + 1).toLowerCase()
      let type = 'noKnow'
      this.typeList.some((item) => {
        if (this.types[item].includes(suffix)) {
          type = item
          return true
        }
      })
      return {name, type, url, suffix, fileName}
    })
  }
  private remove (index) {
    this.$emit('remove', index)
  }
  private beforeMount () {
    this.typeList = Object.keys(this.types)
  }
  // 预览
	private preview(val) {
		const preview = this.$ImgPrview({
			list: this.listShow,
			img: val,
			isHiddenDelBtn: this.isHiddenDelBtn,
		}).then((obj) => {
			console.log(obj.value);
			this.$emit('remove', obj.value);
		});
	}
}
